var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcReceiptEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/receipt-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "receipt-edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4097 2.33203H9.58967C5.17967 2.33203 4.08301 3.51036 4.08301 8.21203V21.3487C4.08301 24.452 5.78634 25.187 7.85134 22.9704L7.86301 22.9587C8.81967 21.9437 10.278 22.0254 11.1063 23.1337L12.2847 24.7087C13.2297 25.957 14.758 25.957 15.703 24.7087L16.8813 23.1337C17.7213 22.0137 19.1797 21.932 20.1363 22.9587C22.213 25.1754 23.9047 24.4404 23.9047 21.337V8.21203C23.9163 3.51036 22.8197 2.33203 18.4097 2.33203ZM17.313 11.6537L16.7297 12.2487H16.718L13.183 15.7837C13.0313 15.9354 12.7163 16.0987 12.4947 16.122L10.9197 16.3554C10.348 16.437 9.95134 16.0287 10.033 15.4687L10.2547 13.882C10.2897 13.6604 10.4413 13.357 10.593 13.1937L14.1397 9.6587L14.723 9.0637C15.108 8.6787 15.5397 8.3987 16.0063 8.3987C16.403 8.3987 16.8347 8.58536 17.313 9.0637C18.363 10.1137 18.0247 10.942 17.313 11.6537Z",
    fill: "#116584"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReceiptEdit);
export default __webpack_public_path__ + "static/media/ic-receipt-edit.abc9036a2b79ba748ad34e49fd52419d.svg";
export { ForwardRef as ReactComponent };